import { Role } from '@contrast-security-inc/base-types'

export type PrefixedRole =
  | 'ROLE_VIEW'
  | 'ROLE_EDIT'
  | 'ROLE_RULES_ADMIN'
  | 'ROLE_ADMIN'
  | 'ROLE_PLATFORM_ORG_MANAGE'
  | 'ROLE_PROTECT_POLICIES_MANAGE'
  | 'ROLE_PROTECT_EXCLUSIONS_MANAGE'
  | 'ROLE_VIEW_AUDIT_LOGS'

const prefixedRoles = [
  'ROLE_VIEW',
  'ROLE_EDIT',
  'ROLE_RULES_ADMIN',
  'ROLE_ADMIN',
  'ROLE_PLATFORM_ORG_MANAGE',
  'ROLE_PROTECT_POLICIES_MANAGE',
  'ROLE_PROTECT_EXCLUSIONS_MANAGE',
  'ROLE_VIEW_AUDIT_LOGS'
] as const

// RBAC permissions are not required to be added in this array
const rolesByLeastPermissive: Role[] = ['VIEW', 'EDIT', 'RULES_ADMIN', 'ADMIN']

const prefixedRoleMap: Record<PrefixedRole, Role> = {
  ROLE_VIEW: 'VIEW',
  ROLE_EDIT: 'EDIT',
  ROLE_RULES_ADMIN: 'RULES_ADMIN',
  ROLE_ADMIN: 'ADMIN',
  ROLE_PLATFORM_ORG_MANAGE: 'PLATFORM_ORG_MANAGE',
  ROLE_PROTECT_POLICIES_MANAGE: 'PROTECT_POLICIES_MANAGE',
  ROLE_PROTECT_EXCLUSIONS_MANAGE: 'PROTECT_EXCLUSIONS_MANAGE',
  ROLE_VIEW_AUDIT_LOGS: 'VIEW_AUDIT_LOGS'
}

const maxReducer = (a, b) => Math.max(a, b)

const isOfTypePrefixedRole = (role: string): role is PrefixedRole =>
  (prefixedRoles as readonly string[]).includes(role)

function transform(roles: PrefixedRole[] | Role[]) {
  return rolesByLeastPermissive[
    roles
      .map((role) =>
        isOfTypePrefixedRole(role) ? prefixedRoleMap[role] : role
      )
      .map((role) => (role ? rolesByLeastPermissive.indexOf(role) : -1))
      .reduce(maxReducer, -1)
  ]
}

export const transformRole = (
  roles: PrefixedRole[] | Role[] = []
): Role | undefined => transform(roles)

export const transformRoleRequired = (roles: PrefixedRole[]): Role =>
  transform(roles)
